export default {
  getPartner(state) {
    return state.partner;
  },
  getPartners(state) {
    return state.partners;
  },
  getUnvaluedPartners(state) {
    return state.unvaluedPartners;
  },
};
